import React from 'react';
import { PumpsNoteEditTemplate } from 'themes/application/pumps/components';
import { observer } from 'mobx-react';
import { PumpsNoteEditViewStore } from 'application/pumps/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new PumpsNoteEditViewStore(rootStore, componentProps), 'pumpsNoteEditViewStore')
@observer
class PumpsNoteEdit extends React.Component {
    render() {
        return <PumpsNoteEditTemplate {...this.props} />
    }
}

export default PumpsNoteEdit;